import React from 'react'
import { Link } from 'react-router-dom'
import { Markup } from 'interweave';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
import SubscribeButton from '../Global/SubscribeButton'

import styles from "./Global.module.css";

import noThumb from "../../images/no-thumb.jpg";

function ChannelBox(channel, videos) {
  let avatar = '';
  if(channel.avatar !== null && channel.avatar.includes('storage/uploads/')) {
    avatar = `${process.env.REACT_APP_API_URL}/${channel.avatar}`;
  }else {
    avatar = channel.avatar;
  }

  return (
    <div className={styles.item}>
      <Link className="block text-center" to={`/profile/${channel.id}/${channel.nice_url}`}>
        <div className={`${styles.avatar} ${channel.is_active ? styles.online : ''}`}>
          <img className={styles.img_circle} src={avatar} onError={e => {e.target.src = noThumb}} alt={channel.name} />
          {/* <LazyLoadImage
            className={styles.img_circle}
              alt={channel.name}
              src={avatar}
              effect="blur"
            /> */}
        </div>
        <h6><Markup content={channel.name}></Markup></h6>
        {
          videos && <b className='text-muted'>45 Videos</b>
        }
        <p>{channel.views} views</p>
      </Link>
      <div className="btn-group pt-2">
        {
          <SubscribeButton size="sm" uid={channel.id} />
        }
      </div>
    </div>
  )
}

export default ChannelBox